import React from "react";
import { useLocation } from "react-router-dom";

function Header() {
  const location = useLocation();

  let MaginLeft = "";
  let Marginright = "";
  let SelectedLang = JSON.parse(localStorage.getItem("LanguageKey") || "{}");

  if (SelectedLang == "ar") {
    MaginLeft = "0px,";
    Marginright = "4.3rem ";
  } else {
    MaginLeft = "4.3rem";
  }

  const hiddenRoutes = [
    "/Messages",
    "/Project/Dashboard",
    "/Project/Task/List",
    "/Project/Tasks/All",
    "/Project/List",
    "/Project/Clients",
    "/Project/Help",
    "/Project/Sprint",
    "/Project/PastSprints",
    "/Project/List/:ClientGUID",
    "/Project/Backlog/:ProjectGUID",
    "/Project/Sprints",
    "/Project/List/:ProjectGUID",
    "/Timesheet/TimesheetHowItWorks"
  ];

  const isDynamicHidden =
    location.pathname.startsWith("/Project/Task/Detail/") ||
    location.pathname.startsWith("/Project/Detail/") ||
    location.pathname.startsWith("/Project/Backlog/") ||
    location.pathname.startsWith("/Project/List/");  
    // location.pathname.startsWith("/Project/List/")

  const shouldHide =
    hiddenRoutes.includes(location.pathname) || isDynamicHidden;

  return (
    <div>
      {!shouldHide && (
        <p className="top-ico">
          <i className="fa fa-thumb-tack i-ico" aria-hidden="true"></i>
          <b>OrgGenie :</b> Welcome to OrgGenie!
          <i className="fa fa-ellipsis-h i-ico1" aria-hidden="true"></i>
        </p>
      )}

      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>
      </div>
    </div>
  );
}

export default Header;